import { computed } from 'vue'

import { useAuthStore } from '@/features/auth/useAuthStore.js'

export function useClubList() {
  const authStore = useAuthStore()
  const clubs = computed(() => {
    const myTenants = authStore.myDetails?.myTenants || []

    return myTenants.map(item => {
      return {
        id: item.tenantId,
        name: item.name,
        description: item.description,
        isRegisteredFinalized: item.isRegisteredFinalized,
      }
    })
  })

  return {
    clubs,
  }
}
